import React, { useEffect } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import {
  getWidgetSpecificProps,
  getWidgetSpecificIsVisible,
  formatDayLabel,
  formatDateDayNumber,
} from "@utils/index";
import { removePayloadKey } from "@store/slices/globalState";
import {
  Container,
  DateCard,
  DayLabel,
  DateNumber,
  SlotCount,
} from "./styles";

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    ),
    ...getWidgetSpecificProps(
      state.configuration?.normalisedConfig,
      ownProps.id
    ),
  };
};

const DateSelector = (props: any) => {
  const { is_visible, slotsData = [], selectedDate , actions } = props;
  const dispatch = useDispatch();
  
  const { selectedDateFromPayload } = useSelector(({ globalState }: any) => ({
    selectedDateFromPayload: globalState?.payloadData?.selectedDate
  }));
  
  const defaultSelectedDate = slotsData?.length > 0 ? slotsData[0]?.date : null;
  const finalSelectedDate = selectedDate || selectedDateFromPayload;
  const currentSelectedDate = finalSelectedDate || defaultSelectedDate;

  if (!is_visible) return <></>;

  useEffect(() => {
    if (!selectedDate && defaultSelectedDate && slotsData?.length > 0) {
      actions?.on_date_select?.forEach((action: any) => {
        if (action && typeof action.funCall === "function") {
          action.funCall({
            ...action.args,
            payloadData: {
              selectedDate: defaultSelectedDate
            }
          });
        }
      });
    }
  }, []);

  const fullState = useSelector((state: any) => state);

  const handleDateClick = (date: string) => {
    if (date !== currentSelectedDate) {
      dispatch(removePayloadKey("selectedSlot"));
    }
    
    actions?.on_date_select?.forEach((action: any) => {
      if (action && typeof action.funCall === "function") {
        action.funCall({
          ...action.args,
          payloadData: {
            selectedDate: date
          }
        });
      }
    });
    
    setTimeout(() => {
      console.log(fullState);
    }, 100);
  };

  return (
    <Container>
      {slotsData?.map((item: any) => {
        const isSelected = currentSelectedDate === item.date;
        const slotCount = item.slots?.length || 0;

        return (
          <DateCard
            key={item.date}
            isActive={isSelected}
            onClick={() => handleDateClick(item.date)}
          >
            <DayLabel isActive={isSelected}>{formatDayLabel(item.date)}</DayLabel>
            <DateNumber isActive={isSelected}>{formatDateDayNumber(item.date)}</DateNumber>
            <SlotCount isActive={isSelected}>
              {slotCount === 0
                ? "No Slot"
                : slotCount === 1
                ? "1 Slot"
                : `${slotCount} slots`}
            </SlotCount>
          </DateCard>
        );
      })}
    </Container>
  );
};

export default connect(mapStateToProps)(DateSelector);

